import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {LessonItem} from "../../types/student-info/studentInfoLessonsShema";
import {Pagination} from "../../types/studentsSchema";

interface StudentState {
    items: LessonItem[] | null;
    pagination: Pagination,
    isLoading: boolean;
    error: string | null;
}

const initialState: StudentState = {
    items: null,
    pagination: {} as Pagination,
    isLoading: true,
    error: null,
};

const studentLessonsSlice = createSlice({
    name: "student",
    initialState,
    reducers: {
        setLessonsData: (state, action) => {
            const {items, pagination} = action.payload;
            state.items = items;
            state.pagination = pagination;
            state.isLoading = false
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
    },
});


export const {setLessonsData, setLoading} = studentLessonsSlice.actions;


export const studentLessonsReducer = studentLessonsSlice.reducer;
